export default () => `
  <div class="content">
    Set the maximum span between roof attachments, should be smallest of the design spans for all zones. If this value is different from the maximum allowable for the product, the lower of the two values is used.
  </div>
`;
